import React from 'react'
import { MailchimpProfile } from 'api/clients/ExternalIntegrationsClient'
import Styles from '../EmailBlock.module.scss'
import { Input } from 'almanac-ui/TextInputField/Input'

type FromInputProps = {
  mailchimpProfile: MailchimpProfile
}

export function FromInput({ mailchimpProfile }: FromInputProps) {
  const { account_name: fromName, username: fromEmail } = mailchimpProfile

  return (
    <div className={Styles.formGroup}>
      <label className={Styles.label} htmlFor="from">
        From
      </label>
      <div className={Styles.selectWrapper}>
        <Input id="from" name="from" className={Styles.textInput} value={`${fromName} • ${fromEmail}`} disabled />
      </div>
    </div>
  )
}
